import axios from 'axios';
import * as c from '../../utils/constants';

export const attributeValueGet = attributeId =>
  axios
    .post('/api/ds-attribute-value', { op: 'list', attributeId })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const attributes = () => dispatch =>
  axios
    .post('/api/ds-user-attribute', { op: 'list' })
    .then(async response => {
      Promise.all(
        response.data.items.map(async item => {
          const values = await attributeValueGet(item.id);
          return { ...item, values: values.items };
        }),
      ).then(values =>
        dispatch({
          type: c.LOAD_USER_ATTRIBUTES,
          payload: values,
        }),
      );
    })
    .catch(error => ({ success: false }));

export const setActiveCategory = value => dispatch =>
  dispatch({
    type: c.SET_ACTIVE_CATEGORY,
    payload: value,
  });



// WEBPACK FOOTER //
// ./src/modules/app/_api.js